import React, {Fragment} from 'react';
import classNames from "classnames";

export type TabContentPropsType = {
    tabName: string|number|symbol,
    tabLabel: any,
    className?: string|string[]|Record<string, any>,
    footer?: any,
    children?: React.ReactNode,
    disabled?: boolean,
    active?: boolean
}

export default (props: TabContentPropsType) => {
    if (props.children) {
        return (
            <Fragment>
                <div className={classNames("tab-content", props.className, {"hidden": !props.active})}>
                    <div className="tab-pane fade in show active">
                        {props.children}
                    </div>
                </div>
                {!!props.footer && <div className="tab-footer">
                    {props.footer}
                    <div className="clearfix"/>
                </div>}
            </Fragment>
        );
    } else {
        return null;
    }
}